// Helper functions for OrderDetailSheet and child components

export const formatSeconds = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export const formatDuration = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return hours > 0 ? `${hours}h ${mins}min` : `${mins}min`;
};

export const computeRecordedMinutes = (timeEntries = []) => {
  let recordedMinutes = 0;
  timeEntries.forEach(e => {
    if (!e.is_active && e.start_time && e.end_time) {
      const sParts = e.start_time.split(':');
      const eParts = e.end_time.split(':');
      if (sParts.length === 2 && eParts.length === 2) {
        const sMins = parseInt(sParts[0]) * 60 + parseInt(sParts[1]);
        const eMins = parseInt(eParts[0]) * 60 + parseInt(eParts[1]);
        const work = eMins - sMins - (e.pause_minutes || 0);
        if (work > 0) recordedMinutes += work;
      }
    }
  });
  return recordedMinutes;
};

export const computeOrderTotals = (order) => {
  const tasks = order?.tasks || [];
  let totalTime = 0;
  let totalCost = 0;
  tasks.forEach(t => {
    totalTime += t.time_minutes || 0;
    if (t.materialien) {
      t.materialien.forEach(m => {
        totalCost += parseFloat(m.kosten) || 0;
      });
    }
  });
  const recordedMinutes = computeRecordedMinutes(order?.time_entries || []);
  const completedTasks = tasks.filter(t => t.completed).length;
  return { totalTime, totalCost, completedTasks, totalTasks: tasks.length, recordedMinutes };
};

export const startSpeechRecognition = (setter, currentValue = "", setIsListening) => {
  if (!('webkitSpeechRecognition' in window) && !('SpeechRecognition' in window)) {
    return false;
  }
  const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
  const recognition = new SR();
  recognition.lang = 'de-DE';
  recognition.continuous = false;
  recognition.interimResults = false;
  recognition.onstart = () => setIsListening(true);
  recognition.onresult = (event) => {
    const transcript = event.results[0][0].transcript;
    setter(currentValue ? `${currentValue} ${transcript}` : transcript);
  };
  recognition.onerror = () => setIsListening(false);
  recognition.onend = () => setIsListening(false);
  recognition.start();
  return true;
};

export const IMAGE_CATEGORIES = [
  { id: "fahrzeugannahme", label: "Fahrzeugannahme" },
  { id: "schaeden", label: "Schäden" },
  { id: "waehrend_arbeit", label: "Während der Arbeit" },
  { id: "fertigstellung", label: "Fertigstellung" },
  { id: "sonstiges", label: "Sonstiges" }
];
